export const JOB_ADDED = 'ipfabric/JobManagement/JOB_ADDED';
export const JOB_QUEUED = 'ipfabric/JobManagement/JOB_QUEUED';
export const JOB_UPDATED = 'ipfabric/JobManagement/JOB_UPDATED';
export const JOB_CANCELLED = 'ipfabric/JobManagement/JOB_CANCELLED';
export const JOB_CANCEL = 'ipfabric/JobManagement/JOB_CANCEL';
export const JOB_STOP = 'ipfabric/JobManagement/JOB_STOP';
export const SET_STOP_JOB = 'ipfabric/JobManagement/SET_STOP_JOB';
export const JOB_STARTED = 'ipfabric/JobManagement/JOB_STARTED';
export const READ_JOB = 'ipfabric/JobManagement/READ_JOB';
export const READ_ALL_JOBS = 'ipfabric/JobManagement/READ_ALL_JOBS';

export const JOB_STATUSES = {
  cancelled: 'cancelled',
  done: 'done',
  error: 'error',
  running: 'running',
  scheduled: 'scheduled',
  stopping: 'stopping',
  stopped: 'stopped',
};

export const JOB_ACTIONS = {
  snapshotClone: 'snapshotClone',
  discovery: 'discovery',
  maintenance: 'maintenance',
  snapshotDelete: 'snapshotDelete',
  snapshotLoad: 'snapshotLoad',
  snapshotUnload: 'snapshotUnload',
  snapshotVerify: 'snapshotVerify',
  deleteDevice: 'deleteDevice',
  report: 'report',
  recalculateSites: 'recalculateSites',
  snapshotArchive: 'snapshotArchive',
  cleanDb: 'cleanDb',
  snapshotDownload: 'snapshotDownload',
  techsupport: 'techsupport',
  topologyCalculation: 'topologyCalculation',
  saveHistoricalData: 'saveHistoricalData',
  loadGraphCache: 'loadGraphCache',
  configurationExport: 'configurationExport',
  configurationImport: 'configurationImport',
  toggleMcp: 'toggleMcp',
  aimFlowPathLookup: 'aimFlowPathLookup',
};

export const STOP_JOB_DISCOVERY_DIALOGUE_NAME =
  'STOP_JOB_DISCOVERY_DIALOGUE_NAME';
